module.exports = __webpack_public_path__ + "static/fonts/Oswald-ExtraLight.eb64279.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-ExtraLight.ttf
// module id = PbOY
// module chunks = 1